import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { OrganizationsManager } from "@/components/app/organizations-manager";

export const Route = createFileRoute("/_authenticated/t1dwpanel/organizations")({
  head: () => ({
    meta: [
      { title: "Organizations | Warrior Volunteer admin" },
      {
        name: "description",
        content: "Manage the shared organization directory and the email domains that link contacts.",
      },
      { property: "og:title", content: "Organizations | Warrior Volunteer admin" },
      {
        property: "og:description",
        content: "Manage the shared organization directory and the email domains that link contacts.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminOrganizationsPage,
});

function AdminOrganizationsPage() {
  return (
    <AppShell eyebrow="Admin" title="Organizations">
      <OrganizationsManager scope="all" />
    </AppShell>
  );
}
